import {React, className, Component} from 'henrybuilt-react-library';
import _ from 'lodash';
import hasPermission from '../../has-permission';

class Page extends Component {
  authGroup = 'admin';

  render(content) {
    if (!this.hasPermission) window.location = `${this.accountsDomain}/login`;

    return this.hasPermission ? (
      <div {...className([`page ${_.kebabCase(this.key)}-page`, this.className])}>
        {content}
      </div>
    ) : null;
  }

  get hasPermission() {
    return hasPermission({user: this.props.session.user, requiredAuthGroup: this.authGroup});
  }

  get accountsDomain() {
    return process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://henrybuilt.com';
  }
}

export default Page;
